export default {
  "anchor": "RuGnf",
  "link": "ootB-"
};